export const createMessageHandler = () => {
  // Get messageHandler injected by Flutter into webview
  const messageHandler = (window as any).messageHandler;

  const hasMessageHandler = !!messageHandler;

  const postMessage = (
    message: 'success' | 'openExternalUrl',
    data?: string
  ) => {
    if (hasMessageHandler) {
      messageHandler.postMessage(JSON.stringify({ message, data }));
    }
  };

  return {
    /** Whether the message handler is available */
    hasMessageHandler,
    /** Send message to mobile app */
    postMessage,
  };
};
